export interface FrameStats {
  fps: number;
  cpuMs: number;
  frameMs: number;
  drawCalls: number;
  triangles: number;
  instances: number;
}

export class FrameTimer {
  private readonly frameSamples: Float32Array;
  private readonly cpuSamples: Float32Array;
  private index = 0;
  private filled = 0;

  constructor(windowSize = 60) {
    this.frameSamples = new Float32Array(windowSize);
    this.cpuSamples = new Float32Array(windowSize);
  }

  push(frameMs: number, cpuMs: number): void {
    this.frameSamples[this.index] = frameMs;
    this.cpuSamples[this.index] = cpuMs;
    this.index = (this.index + 1) % this.frameSamples.length;
    if (this.filled < this.frameSamples.length) this.filled++;
  }

  reset(): void {
    this.index = 0;
    this.filled = 0;
  }

  read(out: FrameStats): void {
    if (this.filled === 0) {
      out.fps = 0;
      out.cpuMs = 0;
      out.frameMs = 0;
      return;
    }
    let frameSum = 0;
    let cpuSum = 0;
    for (let i = 0; i < this.filled; i++) {
      frameSum += this.frameSamples[i]!;
      cpuSum += this.cpuSamples[i]!;
    }
    const avgFrame = frameSum / this.filled;
    out.frameMs = avgFrame;
    out.cpuMs = cpuSum / this.filled;
    out.fps = avgFrame > 0 ? 1000 / avgFrame : 0;
  }
}
